import { Component, OnInit } from "@angular/core";
import { AppService } from "../app.service";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-privacy-policy",
  templateUrl: "./privacy-policy.component.html",
  styleUrls: ["./privacy-policy.component.css"],
})
export class PrivacyPolicyComponent implements OnInit {
  data: any;
  errStatus: boolean
  constructor(private appService: AppService, private spinner: NgxSpinnerService) {
    window.scrollTo(0, 0);
  }

  ngOnInit(): void {
    this.spinner.show();
    this.appService.footerContent({ type: "privacy" }).subscribe((res) => {
      if (res) {
        this.spinner.hide();
        this.data = res;
      } else {
        this.spinner.hide();
        this.data = [];
      }
    }, err => {
      if (err) {
        this.spinner.hide();
        this.data = [];
        this.errStatus = true
      }
    });
  }
}
